export const version = "ethers/5.3.1";
//# sourceMappingURL=_version.js.map